import { Col, Row } from "antd";
import InputComponent from "../../../components/InputComponent";
import { useDocCategoryContext } from "../../../context/DocumentCategoryContext/DocumentCategoryContext";
import { InputStyle } from "./style";

const Info = () => {
	const { docCategoryForm, setDocCategoryForm } = useDocCategoryContext();

	return (
		<>
			<Row gutter={20}>
				<Col span={20}>
					<InputComponent
						title={"Kategori Adı"}
						placeholder="Tamim"
						isRequired
						style={InputStyle}
						value={docCategoryForm?.name}
						onChange={(e) => setDocCategoryForm({ ...docCategoryForm, name: e.target.value })}
					/>
				</Col>
			</Row >
		</>
	);
};

export default Info;
